// extracted by mini-css-extract-plugin
module.exports = {"pickerArea":"FilePicker_pickerArea__28UfG","pickerCardArea":"FilePicker_pickerCardArea__3pQO4","pickerCard":"FilePicker_pickerCard__370hb"};